/**
 * full tracking items test data
 */
export const trackingItemsTestData = [{
  "trackingItems": [
      {
          "trackingNumber": "AZ732424566IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424570IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424583IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424597IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424606IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424610IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424623IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424637IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424645IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424654IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424668IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424671IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424685IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424699IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424708IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424711IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424725IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424739IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424742IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424756IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424760IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424773IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424787IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424795IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424800IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424813IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424827IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424835IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424844IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424858IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424861IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424875IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424889IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424892IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424901IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424915IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416009IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416012IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416026IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416030IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416043IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416057IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416065IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416074IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416088IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416091IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416105IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416114IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416128IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416131IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416145IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-03-15T09:33:04",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416159IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416162IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416176IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416180IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AW732416193IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "SENDER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": 1,
          "deliveryManagerInstructionDetail": "0207q",
          "recipientName": "CHRISTOPHER TAYLOR",
          "destinationCountyCity": "Dublin",
          "destinationCountry": "Ireland"
      }
  ],
  "success": true,
  "errors": []
}]

/**
 * Receiving test data
 */
export const receivingItemsTestData = [{
  "trackingItems": [
      {
          "trackingNumber": "AZ732424566IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424570IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424583IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424597IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424606IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424610IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424623IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424637IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424645IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424654IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424668IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424671IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424685IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424699IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424708IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424711IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424725IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424739IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Dublin 7",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424742IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424756IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424760IE",
          "lastTrackingEventCategoryId": "0",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424773IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424787IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424795IE",
          "lastTrackingEventCategoryId": "2",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424800IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424813IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424827IE",
          "lastTrackingEventCategoryId": "3",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": null,
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424835IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424844IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424858IE",
          "lastTrackingEventCategoryId": "4",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424861IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424875IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424889IE",
          "lastTrackingEventCategoryId": "5",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424892IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424901IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
      {
          "trackingNumber": "AZ732424915IE",
          "lastTrackingEventCategoryId": "6",
          "deliveryManagerAvailable": false,
          "customsPaymentRequired": false,
          "returnType": "RECEIVER",
          "customsPaymentTotalDue": null,
          "customsPaymentDateDue": null,
          "mrn": null,
          "dateDelivered": "2022-05-31T11:55:54",
          "estimatedDeliveryDateTime": null,
          "retailerName": "AMAZON EU SARL",
          "deliveryManagerInstructionSet": null,
          "deliveryManagerInstructionDetail": null,
          "recipientName": "DANIEL BARATUTESTA",
          "destinationCountyCity": "Galway",
          "destinationCountry": "Ireland"
      },
    ],
    "success": true,
    "errors": []
}]

/**
 * Sending test data
 */
export const sendingItemsTestData = [{
  "trackingItems": [
  {
      "trackingNumber": "AW732416009IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416012IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416026IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416030IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416043IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416057IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416065IE",
      "lastTrackingEventCategoryId": "4",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416074IE",
      "lastTrackingEventCategoryId": "6",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416088IE",
      "lastTrackingEventCategoryId": "6",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416091IE",
      "lastTrackingEventCategoryId": "6",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416105IE",
      "lastTrackingEventCategoryId": "6",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416114IE",
      "lastTrackingEventCategoryId": "6",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416128IE",
      "lastTrackingEventCategoryId": "5",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416131IE",
      "lastTrackingEventCategoryId": "5",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416145IE",
      "lastTrackingEventCategoryId": "5",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": "2022-03-15T09:33:04",
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416159IE",
      "lastTrackingEventCategoryId": "0",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": null,
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416162IE",
      "lastTrackingEventCategoryId": "0",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": null,
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416176IE",
      "lastTrackingEventCategoryId": "0",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": null,
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416180IE",
      "lastTrackingEventCategoryId": "2",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": null,
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  },
  {
      "trackingNumber": "AW732416193IE",
      "lastTrackingEventCategoryId": "2",
      "deliveryManagerAvailable": false,
      "customsPaymentRequired": false,
      "returnType": "SENDER",
      "customsPaymentTotalDue": null,
      "customsPaymentDateDue": null,
      "mrn": null,
      "dateDelivered": null,
      "estimatedDeliveryDateTime": null,
      "retailerName": "AMAZON EU SARL",
      "deliveryManagerInstructionSet": 1,
      "deliveryManagerInstructionDetail": "0207q",
      "recipientName": "CHRISTOPHER TAYLOR",
      "destinationCountyCity": "Dublin",
      "destinationCountry": "Ireland"
  }
  ],
  "success": true,
  "errors": []
}];